export const USER_ROLES = {
  Admin: 'Admin',
  CanDeleteContentList: 'CanDeleteContentList',
  CanWriteArticles: 'CanWriteArticles',
  CanCreateNewVersions: 'CanCreateNewVersions',
  CanRepurposeArticles: 'CanRepurposeArticles',
  CanSubedit: 'CanSubEdit',
  CanEditTopic: 'CanEditTopic',
};
